import { render, staticRenderFns } from "./cardBg.vue?vue&type=template&id=a821abe4&scoped=true&"
import script from "./cardBg.vue?vue&type=script&lang=js&"
export * from "./cardBg.vue?vue&type=script&lang=js&"
import style0 from "./cardBg.vue?vue&type=style&index=0&id=a821abe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a821abe4",
  null
  
)

export default component.exports